import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInbox = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.80111 3.5709C5.07434 2.92198 5.70987 2.5 6.41397 2.5H17.5877C18.2903 2.5 18.9248 2.9202 19.199 3.56709L22.9405 12.3948C22.9798 12.4874 23 12.5869 23 12.6875V20.25C23 21.2165 22.2165 22 21.25 22H2.75C1.7835 22 1 21.2165 1 20.25V12.75C1 12.65 1.01998 12.5511 1.05877 12.459L4.80111 3.5709ZM6.41397 4C6.31339 4 6.2226 4.06028 6.18357 4.15299L2.87956 12H8C8.26675 12 8.51343 12.1417 8.64783 12.3721L10.1808 15H13.8192L15.3522 12.3721C15.4852 12.144 15.7284 12.0027 15.9925 12L21.1223 11.9487L17.8179 4.15244C17.7787 4.06003 17.6881 4 17.5877 4H6.41397ZM21.5 13.445L16.4333 13.4957L14.8978 16.1279C14.7634 16.3583 14.5168 16.5 14.25 16.5H9.75C9.48325 16.5 9.23657 16.3583 9.10217 16.1279L7.56922 13.5H2.5V20.25C2.5 20.3881 2.61193 20.5 2.75 20.5H21.25C21.3881 20.5 21.5 20.3881 21.5 20.25V13.445Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgInbox;
